export default __webpack_public_path__ + "static/media/Woman_Phone.6e68d985.png";